import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../../api";
import { createError } from "../../../errors";
import { COURSES_PATH, type LearningCoachCourse } from "./types";
import { useSendCommonQueryError } from "./useSendCommonQueryError";

// 起票で選べるコース。モーダルを開くたびに取り直す（閉じている間は取らない）。
// boron が lc へ照会する API のため、フォーカス復帰での取り直しと自動の再試行はしない。
// 401・メンテナンス・緊急停止は既存の共通処理に渡す
export const useFetchLearningCoachCourses = ({
  sectionId,
  enabled,
}: {
  sectionId: string;
  enabled: boolean;
}) => {
  const result = useQuery<LearningCoachCourse[]>({
    queryKey: [COURSES_PATH, sectionId],
    queryFn: async () => {
      const { response, data } = await boronClient.GET(COURSES_PATH, {
        params: { path: { section_id: sectionId } },
      });
      if (response.ok && data) {
        return data.courses;
      }
      throw await createError(response);
    },
    enabled,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });
  useSendCommonQueryError(result.error);

  return result;
};
